import type { EvergladesProductsApiSuccess } from '@shared/types/types.ts';
import { FASHION } from '@tilelist/domain/composition/BracketLayout.ts';
import { composeTileListLite } from '@tilelist/domain/composition/TileListLiteCompositionStrategy.ts';
import type { TileListPageLayout } from '@tilelist/domain/composition/TileListPage.ts';
import type { PageLoadContext, PageLoadStrategy } from './PageLoadStrategy.ts';

/**
 *
 *
 *
 *
 */
export class LiteTileListStrategy implements PageLoadStrategy {
    intents(_ctx: PageLoadContext) {
        return ['ranked', 'context'] as const;
    }

    async compose(response: EvergladesProductsApiSuccess, ctx: PageLoadContext): Promise<TileListPageLayout> {
        const { rule, tileListItems, count, assortment } = composeTileListLite(response);
        const sortiertnach = ctx.queryParams.sortiertnach || undefined;

        return {
            tileListItems,
            tracking: {},
            page: sortiertnach ? { sortiertnach } : {},
            isFallback: tileListItems.length === 0,
            pagination: { currentPage: 1, currentOffset: 0, lastPage: 1 },
            rankedCount: count,
            sponsoredCount: 0,
            displayCount: count,
            context: {
                rule,
                layout: FASHION,
                searchContext: {
                    rule,
                    topNImplicit: assortment ? { assortmentNavigation: [assortment] } : undefined,
                },
            },
        };
    }
}
